import styled from 'styled-components';

export const StyledCopyableText = styled.div`
  &:hover {
    cursor: pointer;
    text-decoration: underline;
  }
`;
